// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDKLm-4n4nTfzrzCfmCbN5HS2RclAGa90U",
    authDomain: "green-gusto.firebaseapp.com",
    projectId: "green-gusto",
    storageBucket: "green-gusto.firebasestorage.app",
    messagingSenderId: "55739971163",
    appId: "1:55739971163:web:72ed756e1de5c97c4d317e",
    measurementId: "G-HK76SJ943E"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);

export { app, analytics, auth, db };